import * as React from 'react';
import Paper from 'material-ui/Paper';
import diyLightRawTheme from 'diy/material-ui/diyLightRawTheme';
import {autoprefixer} from 'diy/material-ui/autoprefixer';

type SvgIconClass = typeof __MaterialUI.SvgIcon;

interface InfoBoxProps {
    iconColor?: string;
    Icon: SvgIconClass;
    paperStyles?: React.CSSProperties;
    paperCssClass?: string;
    dataTestId?: string;
}

export class InfoBox extends React.Component<InfoBoxProps, {}> {
    static defaultProps = {
        iconColor: diyLightRawTheme.palette.textColor
    };

    render() {
        let styles = this.getStyles();

        return (
            <Paper className={this.props.paperCssClass} style={styles.paper} rounded={false}
                data-test-id={this.props.dataTestId}
            >
                {this.renderIcon()}
                {this.props.children}
            </Paper>
        );
    }

    private renderIcon() {
        let styles = this.getStyles();
        let Icon = this.props.Icon;

        return <Icon style={styles.icon} color={this.props.iconColor} />;
    }

    private getStyles() {
        return {
            paper: autoprefixer(Object.assign({
                padding: "16px 24px",
                fontFamily: '"Open Sans", sans-serif',
                fontSize: "13px",
                fontWeight: 600,
                display: "flex",
                alignItems: "center"
            }, this.props.paperStyles)),
            icon: autoprefixer({
                height: "16px",
                marginRight: "10px",
                flexShrink: 0
            })
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/custom-components/InfoBox.tsx
 **/